module.exports = __webpack_public_path__ + "img/surgeries.42744d54.svg";